import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Linkedin, ArrowRight } from 'lucide-react';

const Footer = () => {
  const services = [
    'Accounting and Book-keeping',
    'Auditing and Assurance',
    'Tax Advisory',
    'GST Advisory Services',
    'Company Registration',
    'Company and LLP Compliances',
  ];

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-gray-950 text-gray-300">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          {/* Company Info */}
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 flex items-center justify-center">
                <img 
                  src="/logo.png" 
                  alt="CA Logo"
                  className="w-12 h-12 object-contain"
                />
              </div>
              <div className="flex flex-col">
                <span className="font-bold text-white text-lg leading-tight">Kanish Jariwala</span>
                <span className="text-sm text-gray-400">& Associates</span>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed text-sm">
              Our customer centric approach goes beyond compliance. We partner with you to optimize taxes, improve cash flow, support business growth and build a sustainable relationship.
            </p>
            <div className="flex space-x-3">
              <a 
                href="https://www.linkedin.com/in/ca-kanish-jariwala/" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors duration-300"
              >
                <Linkedin size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path} 
                    className="flex items-center group hover:text-blue-400 transition-colors duration-200 text-sm"
                  >
                    <ArrowRight size={14} className="mr-2 group-hover:translate-x-1 transition-transform" />
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Our Services</h3>
            <ul className="space-y-3">
              {services.slice(0, 5).map((service) => (
                <li key={service}>
                  <Link 
                    to="/services" 
                    className="flex items-center group hover:text-blue-400 transition-colors duration-200 text-sm"
                  >
                    <ArrowRight size={14} className="mr-2 group-hover:translate-x-1 transition-transform" />
                    <span className="line-clamp-1">{service}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-blue-400 flex-shrink-0 mt-1" />
                <span className="leading-relaxed text-sm">
                  32, Ultimate Business Center,<br />
                  M.G. Marg, Fort,<br />
                  Mumbai - 400001
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="text-blue-400 flex-shrink-0" />
                <a href="tel:9082738204" className="hover:text-blue-400 transition-colors text-sm">
                  +91 9082738204
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-blue-400 flex-shrink-0" />
                <a href="mailto:kanish@cakja.co.in" className="hover:text-blue-400 transition-colors text-sm break-all">
                  kanish@cakja.co.in
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Clock size={18} className="text-blue-400 flex-shrink-0 mt-1" />
                <div className="text-sm">
                  <p>Mon - Fri: 10:00 AM - 7:30 PM</p>
                  <p>Sat: 10:00 AM - 5:00 PM</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {new Date().getFullYear()} Kanish Jariwala & Associates. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="hover:text-blue-400 transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-blue-400 transition-colors">Terms of Service</a>
              <a href="#" className="hover:text-blue-400 transition-colors">Disclaimer</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
